/*tslint:disable:no-invalid-this */
/*tslint:disable:no-invalid-this */ export function OnChange(defaultValue) {
    var sufix = 'Change';
    return function OnChangeHandler(target, propertyKey) {
        var _key = " __" + propertyKey + "Value";
        Object.defineProperty(target, propertyKey, {
            get: function () { return this[_key]; },
            set: function (value) {
                var prevValue = this[_key];
                this[_key] = value;
                if (prevValue !== value && this[propertyKey + sufix]) {
                    this[propertyKey + sufix].emit(value);
                }
            }
        });
    };
}
/* tslint:enable */
//# sourceMappingURL=decorators.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/utils/decorators.js
// module id = ../../../../angular-bootstrap-md/utils/decorators.js
// module chunks = 3